export default __webpack_public_path__ + "static/media/S4xCLUES1.964de170.jpg";